// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3b63d8b9","239":"0042162d","732":"959e116b"}[chunkId] + ".chunk.js";
};